__turbopack_context__.v({
  "body": "StickyWidget-module-scss-module__5FTVjq__body",
  "closeBtn": "StickyWidget-module-scss-module__5FTVjq__closeBtn",
  "ctaBtn": "StickyWidget-module-scss-module__5FTVjq__ctaBtn",
  "getUpTo": "StickyWidget-module-scss-module__5FTVjq__getUpTo",
  "img": "StickyWidget-module-scss-module__5FTVjq__img",
  "imgCol": "StickyWidget-module-scss-module__5FTVjq__imgCol",
  "percent": "StickyWidget-module-scss-module__5FTVjq__percent",
  "root": "StickyWidget-module-scss-module__5FTVjq__root",
  "scholarship": "StickyWidget-module-scss-module__5FTVjq__scholarship",
  "textCol": "StickyWidget-module-scss-module__5FTVjq__textCol",
  "tnc": "StickyWidget-module-scss-module__5FTVjq__tnc",
});
